import * as React from 'react';

import {
  Breakpoint,

  useDimensions,
} from '@bluecurrent/web-component-lib';

import Header from './Sections/Header';
import Footer from './Sections/Footer';

export default function Layout(props) {
  const size = useDimensions();

  const [hasFooter, setFooter] = React.useState(true);

  React.useEffect(() => {
    if (window.location.pathname.startsWith('/forms/')) setFooter(false);
  }, []);

  React.useEffect(() => {
    /* eslint-disable no-param-reassign */
    const handleMessage = (event) => {
      if (event.data['datawrapper-height']) {
        const iframes = document.querySelectorAll('iframe');

        Object.entries(event.data['datawrapper-height']).forEach(([, height]) => {
          iframes.forEach((iframe) => {
            if (iframe.contentWindow === event.source) {
              iframe.style.height = `${height}px`;
            }
          });
        });
      }
      /* eslint-enable no-param-reassign */
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div
      style={{
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          height: size.width < Breakpoint.lg
            ? 80
            : 125,
        }}
      >
        <Header />
      </div>
      <main>
        {props.children}
      </main>
      {
        hasFooter && (
          <Footer />
        )
      }
    </div>
  );
}
